import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {
  BaseOneResponseInterface,
  GetManyResponseInterface,
} from '../../../shared/model/interface/crud-response-interface.model';
import {
  IFeedbackModalData,
  IQuestionGroup,
  IRatingFeedback,
  ISubmitFeedback,
  ISubmitHomeFeedback,
} from './feedback-modal.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackModalService {
  private routes = {
    feedbacks: '/feedback',
    submitFeedback: '/feedback/submit-feedback',
    getHomeFeedback: '/feedback-question-assignment/get-home-feedback',
    submitHomeFeedback: '/feedback/submit-home-feedback',
  };
  private openModalSubject = new Subject<void>();
  public openModal$ = this.openModalSubject.asObservable();

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private api: string) {}

  public openModal(): void {
    this.openModalSubject.next();
  }

  public getFeedbacks(params?: HttpParams): Observable<GetManyResponseInterface<IFeedbackModalData>> {
    return this.http.get<GetManyResponseInterface<IFeedbackModalData>>(`${this.api}${this.routes.feedbacks}`, {
      params,
    });
  }

  public getHomeFeedback(): Observable<BaseOneResponseInterface<IQuestionGroup>> {
    return this.http.get<BaseOneResponseInterface<IQuestionGroup>>(`${this.api}${this.routes.getHomeFeedback}`);
  }

  public submitFeedback(
    payload: ISubmitFeedback<IRatingFeedback>,
  ): Observable<BaseOneResponseInterface<IFeedbackModalData>> {
    return this.http.post<BaseOneResponseInterface<IFeedbackModalData>>(
      `${this.api}${this.routes.submitFeedback}`,
      payload,
    );
  }

  public submitHomeFeedback(payload: ISubmitHomeFeedback): Observable<BaseOneResponseInterface<IFeedbackModalData>> {
    return this.http.post<BaseOneResponseInterface<IFeedbackModalData>>(
      `${this.api}${this.routes.submitHomeFeedback}`,
      payload,
    );
  }
}
